import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import RichText from './rich-text';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const HeaderDrawer = ({
    links,
    isOpen,
    setIsOpen
}) => {
    const dialogRef = useRef();

    const close = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') { close(); }
        };

        window.addEventListener('keydown', handleKeyDown, { passive: true });

        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    const getUrlSegment = (typename, item) => {
        let urlSegment;
        if (typename === 'BvaBusinessResourcePage') {
            urlSegment = 'resources';
        } else if (typename === 'BvaBusinessCaseStudyPage') {
            urlSegment = 'case-studies';
        } else if (typename === 'BvaBusinessLandingSubPage') {
            urlSegment = item?.parent?.bvaBusinessLandingPageCollection?.items?.[0]?.slug;
        }

        return urlSegment;
    };

    return (
        <>
            <div
                className={`${isOpen ? 'bg-white h-auto relative layout-container pb-50 hidden md:block' : 'hidden'}`}
                inert={isOpen ? null : ''}
                ref={dialogRef}>
                <div className='w-full md:mt-90'>

                    {links && (
                        <div
                            className='flex flex-wrap flex-row gap-y-20'>
                            {links?.map((link, idx) => (
                                <div
                                    className='md:px-10 md:w-4/12'
                                    key={idx}>
                                    <div
                                        className='flex flex-col'>
                                        {(link?.headerLink) && (
                                            <a
                                                className={`type-style-3 ${link?.subLinkSize === 'Small' ? 'md:mb-15' : 'md:mb-20'}`}
                                                href={`/${link?.headerLink?.slug}`}>
                                                {link?.headerLink?.title}
                                            </a>
                                        )}
                                        {link?.subLinksCollection?.items?.length > 0 && (
                                            link?.subLinksCollection?.items?.map((sublink, i) => {
                                                if (sublink?.body) {
                                                    return (
                                                        <RichText
                                                            className={`${link?.subLinkSize === 'Small' ? 'type-style-7' : 'type-style-3'} md:mb-20`}
                                                            key={i}
                                                            {...sublink?.body} />
                                                    );
                                                } else {
                                                    if (sublink?.__typename === 'BvaBusinessResourceListingPage' || sublink?.__typename === 'BvaBusinessCaseStudyListingPage') {
                                                        return (
                                                            <a
                                                                className={`${link?.subLinkSize === 'Small' ? 'type-style-7' : 'type-style-3'} md:mb-20`}
                                                                href={`/${sublink?.slug}`}
                                                                key={i}>
                                                                {sublink?.title}
                                                            </a>
                                                        );
                                                    } else {
                                                        return (
                                                            <a
                                                                className={`${link?.subLinkSize === 'Small' ? 'type-style-7' : 'type-style-3'} md:mb-20`}
                                                                href={`/${getUrlSegment(sublink?.__typename, sublink)}/${sublink?.slug}`}
                                                                key={i}>
                                                                {sublink?.title}
                                                            </a>
                                                        );
                                                    }
                                                }
                                            })
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    links: PropTypes.array,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
};

HeaderDrawer.propTypes = propTypes;

export default HeaderDrawer;
